import React from 'react';
import { useTranslation } from "react-i18next"
import { Colors } from '../../themes/Colors';
import TextBase from '../text';
import { useSelector } from 'react-redux';
import LocalStorage from '../../defined/localStorage';
import CustomSpinner from '../CustomSpinner';
import { resolveCssVarValue } from '../../utils/CommonFunction';

const brand = JSON.parse(LocalStorage.getItem('branding'))

export default function ButtonGradient(props) {
  const { t } = useTranslation()
  const whiteLabel = useSelector((state) => state.User?.branding);

  const style = props.style || {};
  const iconSize = props.iconSize || 'var(--fs-md)';
  const iconStyle = props.iconStyle || {};
  const textStyle = props.textStyle || {};
  const Icon = props.icon;
  const opacity = props?.opacity ? props?.opacity : 1;

  const renderBackground = () => {
    const whiteLabelBackground = `linear-gradient(222.6deg, ${whiteLabel?.web_button_color||brand?.web_button_color||'#FBC916'} 0%, ${whiteLabel?.web_button_color||brand?.web_button_color||'#FBC916'} 100%)`;
    const defaultBackground = `linear-gradient(222.6deg, #FBC916 0%, #FBB516 100%)`;
    if (brand||whiteLabel) {
      return whiteLabelBackground;
    } else {
      return defaultBackground;
    }
  };

  return (
    <div
      {...props}
      style={{
        ...style,
        opacity: props.disabled?"0.5":opacity,
        background: props.backgroundColor ? props.backgroundColor : renderBackground()
      }}
      className="button-gradient"
      onClick={() => {
        if (props.loading||props.disabled) return;
        props.onClick && props.onClick();
      }}>
      {props.loading ? (
        <CustomSpinner size={resolveCssVarValue('--fs-xl')*1.32075} color="#fff" />
      ) : (
        <>
          {Icon ? (
            <Icon
              width={iconSize}
              height={iconSize}
              style={{ marginRight: 'calc(var(--sp-md2)*1.41509)', ...iconStyle }}
            />
          ) : null}

          <TextBase
            size={'var(--fs-md2)'}
            style={{
              ...(props.textStyle||{})
            }}
            color={!textStyle.color?Colors.white:textStyle.color}>
            {t(props.title) || 'Click'}
          </TextBase>
        </>
      )}
    </div>
  );
}
